import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "./chunks/tslib.es6.js";
import { JSONSupport as t } from "./core/JSONSupport.js";
import { clamp as r } from "./core/mathUtils.js";
import { property as e } from "./core/accessorSupport/decorators/property.js";
import "./core/arrayUtils.js";
import "./core/has.js";
import { cast as i } from "./core/accessorSupport/decorators/cast.js";
import { reader as s } from "./core/accessorSupport/decorators/reader.js";
import { subclass as p } from "./core/accessorSupport/decorators/subclass.js";
import { writer as n } from "./core/accessorSupport/decorators/writer.js";
import { ensureNumber as a } from "./core/accessorSupport/ensureType.js";
import c from "./geometry/Point.js";
import { cyclicalDeg as l } from "./views/3d/support/mathUtils.js";

var _u;

var m = _u = /*#__PURE__*/function (_t) {
  _inherits(u, _t);

  var _super = _createSuper(u);

  function u() {
    var _this;

    _classCallCheck(this, u);

    for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
      o[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(o)), _this.position = new c([0, 0, 0]), _this.heading = 0, _this.tilt = 0, _this.fov = 55;
    return _this;
  }

  _createClass(u, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(o, t, r, e) {
      if (o && "object" == typeof o && ("x" in o || Array.isArray(o))) {
        var _i = {
          position: o
        };
        return null != t && (_i.heading = t), null != r && (_i.tilt = r), null != e && (_i.fov = e), _i;
      }

      return o;
    }
  }, {
    key: "writePosition",
    value: function writePosition(o, t, r, e) {
      var i = o.clone();
      i.x = a(o.x || 0), i.y = a(o.y || 0), i.z = o.hasZ ? a(o.z || 0) : o.z, t[r] = i.write({}, e);
    }
  }, {
    key: "readPosition",
    value: function readPosition(o, t) {
      var r = new c();
      return r.read(o, t), r.x = a(r.x || 0), r.y = a(r.y || 0), r.z = r.hasZ ? a(r.z || 0) : r.z, r;
    }
  }, {
    key: "equals",
    value: function equals(o) {
      return !!o && this.tilt === o.tilt && this.heading === o.heading && this.fov === o.fov && this.position.equals(o.position);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _u({
        position: this.position.clone(),
        heading: this.heading,
        tilt: this.tilt,
        fov: this.fov
      });
    }
  }]);

  return u;
}(t);

o([e({
  type: c,
  json: {
    write: {
      isRequired: !0
    }
  }
})], m.prototype, "position", void 0), o([n("position")], m.prototype, "writePosition", null), o([s("position")], m.prototype, "readPosition", null), o([e({
  type: Number,
  nonNullable: !0,
  json: {
    write: {
      isRequired: !0
    }
  }
}), i(function (o) {
  return l.normalize(a(o));
})], m.prototype, "heading", void 0), o([e({
  type: Number,
  nonNullable: !0,
  json: {
    write: {
      isRequired: !0
    }
  }
}), i(function (o) {
  return r(a(o), -180, 180);
})], m.prototype, "tilt", void 0), o([e({
  type: Number,
  nonNullable: !0,
  json: {
    read: !1,
    write: !1
  }
})], m.prototype, "fov", void 0), m = _u = o([p("esri.Camera")], m);
var d = m;
export { d as default };